import React from 'react';
import PropTypes from 'prop-types';

import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider';

import ErrorHandler from '../ErrorHandler';
import Auth0Provider from '../Auth0Provider';
import Layout from '../theme/Layout';

function Root({ children, ...rest }) {
  // rest: auth0Config, auth0RPConfig
  return (
    <>
      <NdsThemeProvider>
        <ErrorHandler>
          <Auth0Provider {...rest}>
            <Layout>{children}</Layout>
          </Auth0Provider>
        </ErrorHandler>
      </NdsThemeProvider>
    </>
  );
}

Root.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Root;
